import React from 'react'

import HomeLogin from './HomeLogin'
import { Page } from './style'

const Home = () => (
    <Page>
        <HomeLogin />
    </Page>
)

export default Home
